module.exports = __webpack_public_path__ + "img/class2.b5be821a.png";